import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-deliveries',
  templateUrl: './portfolio-deliveries.component.html',
  styleUrls: ['./portfolio-deliveries.component.scss']
})
export class PortfolioDeliveriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
